import { useEffect } from "react";

function EditorAction () {
    const ifFollowBlockDefinedMoveCamera = (tracking_id) => {
        if(typeof window.followBlock !== "function") {
            return;
        }

        window.followBlock(tracking_id);
    }

    return { ifFollowBlockDefinedMoveCamera }
}

export default EditorAction